import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { nowBasicCheckResponseAccessorGetNowFirstPickupSlotDayAndTime } from '../../../../now'
import { useProductPageContext } from '../../productPageContext'

export const ProductBuyBoxNowDeliveryOptionPickupMessage: FC = () => {
  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  const { nowDetails } = useProductPageContext()

  const pickupSlotData =
    nowBasicCheckResponseAccessorGetNowFirstPickupSlotDayAndTime(
      nowDetails.nowDataPerProductCurrentVariantResponse,
    )

  return pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V1 ||
    pdpDeliveryOptions.variant === EXPERIMENT_VARIATION.V2 ? (
    <FormattedMessage
      id="general.label.now.product.pickupAvailable"
      values={{
        day: pickupSlotData?.pickupDay,
        hour: pickupSlotData?.pickupStartTime,
      }}
    />
  ) : (
    <FormattedMessage
      id="general.label.now.product.pickupAvailableShort"
      values={{
        day: pickupSlotData?.pickupDay,
        hour: pickupSlotData?.pickupStartTime,
      }}
    />
  )
}
